import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './ModeratorUploadFolder.css';

const MODERATOR_ROOT =
  process.env.REACT_APP_MODERATOR_START_PATH || '/moderator';

function ModeratorUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={MODERATOR_ROOT}
      sessionPrefix="moderator_folder"
    />
  );
}

ModeratorUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default ModeratorUploadFolder;
